import { fetchCities } from 'syft-acp-core/api/resources/cities'
import { takeLatestApiCall } from './helpers'

export default function* root() {
  yield takeLatestApiCall('CITIES_FETCH', fetchCities)
}
